// extracted by mini-css-extract-plugin
export default {"wrapper":"entity-constructor_wrapper__4QGXj","help":"entity-constructor_help__yQaQ-"};